import React from "react";
import type { MultipleChoiceQuestion } from "@r6digital/rapidstor-types/types/Questionnaire";
import BigHeader from "../BigHeader";
import MultipleChoiceResponseCard from "./MultipleChoiceResponseCard";
import { Row } from "react-bootstrap";
import SmallDetail from "../SmallDetail";
import classes from "./Question.module.scss";
import store from "../../store";
import { selectResponses, setResponse } from "../../store/questionnaireSlice";
import { useSelector } from "react-redux";
import Tooltip from "./Tooltip";

interface Props {
  id: string;
  question: MultipleChoiceQuestion;
}

function MultipleChoiceQuestion({ id, question }: Props) {
  const questionnaireResponses = useSelector(selectResponses);

  const onSelect = (answer: string | boolean | number) =>
    store.dispatch(setResponse({ id, response: answer }));

  const responses = question.responses.map((response, index) => {
    return (
      <MultipleChoiceResponseCard
        key={index}
        question={question}
        response={response}
        onSelect={onSelect}
        selected={questionnaireResponses?.[id] === response.answer}
      />
    );
  });

  return (
    <div>
      <div className={"d-flex"}>
        <BigHeader className={classes.title}>{question.title}</BigHeader>
        {question.tooltip && <Tooltip>{question.tooltip}</Tooltip>}
      </div>
      <Row className={classes.responseRow}>{responses}</Row>
      {question.extraText && (
        <SmallDetail style={{ opacity: 0.7 }}>{question.extraText}</SmallDetail>
      )}
    </div>
  );
}

export default MultipleChoiceQuestion;
